export const money = (n) =>
  new Intl.NumberFormat("en-UG", { maximumFractionDigits: 0 }).format(Math.round(Number(n || 0)));

export const ugx = (n) => `UGX ${money(n)}`;

export const shortDate = (d) => {
  if (!d) return "—";
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return d;
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const today = () => new Date().toISOString().slice(0, 10);

export const addDays = (days) =>
  new Date(Date.now() + days * 86400000).toISOString().slice(0, 10);

export const monthStart = () => today().slice(0, 8) + "01";
export const yearStart = () => today().slice(0, 4) + "-01-01";
